<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 23"
    fill="none"
    class="app-logo app-logo--rail"
    role="img"
    aria-label="Aetosky"
  >
    <path
      d="M23.6128 8.25781L23.9263 8.7832H23.9312V8.78223L29.5298 7.17578L33.1763 9.92773L30.7827 9.28711L26.0347 12.2607L26.0366 12.2637L32.1909 22.4707H26.1353L26.0063 17.3301L24.2544 22.4707L21.2495 18.8477C22.7223 16.9051 24.7279 14.1225 25.8823 12.3584C25.8835 12.3566 25.8841 12.3543 25.8853 12.3525L25.8765 12.3584L24.1011 13.4717V13.4658L25.9771 12.2012H25.9761L24.1001 13.4658L19.4038 16.6318L15.5171 19.252L10.7505 22.4707H0.82373L5.56592 14.4326H17.5425L15.0493 11.4287L15.0796 11.4238L14.6313 10.8828L19.936 9.78027L13.1587 9.1084L8.99951 4.09961L18.7173 6.65137L6.12256 0.529297H18.9507L23.6128 8.25781Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped>
.app-logo {
  display: block;
  object-fit: contain;
  color: #ffffff;
}

.app-logo--rail {
  height: 20px;
  max-width: 34px;
}
</style>
